/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomFilterTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import CustomFilterV2 from "./CustomFilterV2";

function CustomFilterTemplate({
  handleDiscard,
  handleClickApply,
  sections = [],
  showClearAll = true
}) {
  const [anchorNotificationFilter, setAnchorNotificationFilter] =
    useState(null);
  const [openNotificationFilter, setOpenNotificationFilter] = useState(false);

  const handleFilterIconClick = (event) => {
    setAnchorNotificationFilter(event.currentTarget);
    setOpenNotificationFilter(true);
  };

  const handleFilterIconClose = () => {
    setAnchorNotificationFilter(null);
    setOpenNotificationFilter(false);
  };

  const handleApplyFilters = async (action) => {
    switch (action) {
      case "discard":
        handleDiscard();
        break;

      case "cancel":
        handleFilterIconClose();
        break;

      case "apply":
        handleClickApply();
        handleFilterIconClose();
        break;

      default:
        break;
    }
  };

  return (
    <CustomFilterV2
      anchorEl={anchorNotificationFilter}
      open={openNotificationFilter}
      widthPerColumn="250px"
      handleClick={handleFilterIconClick}
      handleClose={handleFilterIconClose}
      handleFilterButton={handleApplyFilters}
      showClearAll={showClearAll}
      handleClearAll={() => handleApplyFilters("discard")}
      sections={sections}
    />
  );
}

CustomFilterTemplate.propTypes = {
  handleDiscard: PropTypes.func,
  handleClickApply: PropTypes.func,
  sections: PropTypes.array,
  showClearAll: PropTypes.bool,
};

CustomFilterTemplate.defaultProps = {
  handleDiscard: () => {},
  handleClickApply: () => {},
  sections: [],
  showClearAll: true,
};

export default CustomFilterTemplate;
